module.exports = __webpack_public_path__ + "img/anne_n.4ae36668.png";